export default {
  namespaced: true,
  security_self_audit: {
    title: "Auto Auditoria de Segurança",
    template: {
      title: "Modelos de Formulário",
      name: "Nome",
      question: "Pergunta",
      add_new_field: "Adicionar um Novo Campo",
      type_response: "Tipo de Resposta",
      field_name: "Nome do Campo",
      field_types: "Tipos de Campo",
      field_type_config: "Configuração do Tipo de Campo",
      options: "Opções",
      option_name: "Nome da Opção",
      add_option: "Adicionar uma Opção",
      added_options: "Opções Adicionadas",
    },
    form_validations: {
      name: "O nome é obrigatório",
      type: "O tipo é obrigatório",
    },
    form: {
      title: "Formulário de Risco",
    },
    required: "Obrigatório",
    close: "Fechar",
    Apply: "Aplicar",
    comment: "Comentário",
    file: "Arquivos",
    select_template: "Selecionar Modelo",
    review_comments: "Comentários de Revisão",
    reference_number: "Referência",
    template_name: "Nome do Modelo",
    btn_start_form: "Iniciar Formulário",
    btn_send_to_review: "Enviar para Revisão",
    btn_approve: "Aprovar",
    btn_reject: "Rejeitar",
    btn_reassign: "Reatribuir",
    btn_add_comment: "Adicionar Comentário",
    add_comment_placeholder: "Adicione um comentário...",
    states: {
      title: "Estado",
      created: "Criado",
      in_review: "Em Revisão",
      approved: "Aprovado",
      not_approved: "Não Aprovado",
      reassigned: "Reatribuído",
      reasigned: "Reatribuído",
    },
    history: {
      title: "Histórico",
      user: "Usuário",
      date: "Data"
    },
    fill_form: "Auditoria criada. Preencha o formulário agora.",
    failed_create_audit: "Falha ao criar a auditoria",
    answers_saved: "Respostas salvas",
    error_loading_audit: "Erro ao carregar a auditoria de segurança",
    status_updated: "Estado atualizado para {newStatus}",
    failed_update_status: "Falha ao atualizar o status",
    status: "Status",
    new_audit: "Nova auditoria"
  },
  confirm_cancel: "Tem certeza de que deseja cancelar esta auditoria?",
  canceled: "Auditoria cancelada",
};
